import React, { useState, useEffect } from 'react';

const Component = (props: any) => {
return (
<>
regist
</>
);
};

export default Component;